module.exports = __webpack_public_path__ + "img/pic06.dc0f5020.jpg";